import { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import shevron from "./assets/shevron.svg";

const CustomSelectContainer = styled.div`
  position: relative;
  width: ${(props) => (props.width ? props.width : "80px")};
  cursor: pointer;
  border: ${(props) => (props.withBorder ? "1px solid #949494" : "none")};
  height: 35px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 8px;

  @media (max-width: 577px) {
    width: ${(props) => (props.mobileWidth ? props.mobileWidth : "80px")};
  }
`;

const DropDown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  border: 1px solid #949494;
  border-radius: 10px;
  display: block;
  z-index: 99999;
  list-style-type: none;

  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  li {
    padding: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgb(0, 0, 0);
    opacity: 0.8;
  }

  li:hover {
    background: rgba(255, 232, 217, 1);
  }
`;

const Shevron = styled.img`
  position: absolute;
  top: 7px;
  right: 7px;
`;

export const CustomSelect = (props) => {
  const [isOpenList, setIsOpenList] = useState(false);
  const selectRef = useRef(null);
  const {
    children,
    value,
    width,
    placeholder,
    showShevron = true,
    withBorder = true,
    onClick,
    mobileWidth,
  } = props;

  const onClickHandler = () => {
    if (onClick) {
      onClick();
    }
    setIsOpenList((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpenList(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <CustomSelectContainer
      withBorder={withBorder}
      width={width}
      ref={selectRef}
      onClick={onClickHandler}
      mobileWidth={mobileWidth}
    >
      {showShevron && <Shevron src={shevron} alt="shevron" />}
      <div>{placeholder ? placeholder : value}</div>
      {isOpenList && <DropDown>{children}</DropDown>}
    </CustomSelectContainer>
  );
};
